export enum Organization {
  OpenEnglish = 'oe',
  NextU = 'nextu',
  OpenEnglishJunior = 'oejr',
}
